import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@gearbox-protocol/deploy-tools-ui";
import { shortAddress } from "@gearbox-protocol/sdk/onchain";
import type { FC } from "react";
import type { Address } from "viem";

import type { DetailsEntry, TokensList } from "../../../model";

export interface TokenListProps {
  data: DetailsEntry[];
  tokens: TokensList;
}

export const TokenList: FC<TokenListProps> = ({ data, tokens }) => {
  return (
    <div className="flex flex-col gap-2">
      {data.map(({ token, account, description }, idx) => {
        const tokenAddrLc = (token ?? "0x").toLowerCase() as Address;
        const meta = token ? tokens[tokenAddrLc] : undefined;
        const symbol = meta?.symbol ?? meta?.title;
        const key = `${token ?? account ?? "x"}-${idx}`;
        return (
          <div key={key} className="flex items-center min-w-0 gap-2">
            <div className="flex-1 min-w-0">
              {description && (
                <div
                  className={
                    account
                      ? "text-[10px] text-gray-400"
                      : "text-xs text-gray-300"
                  }
                >
                  {description}
                </div>
              )}
              {symbol ? (
                <div className="text-sm leading-tight truncate">{symbol}</div>
              ) : token ? (
                <TooltipProvider delayDuration={0}>
                  <Tooltip>
                    <TooltipTrigger asChild>
                      <div className="text-sm leading-tight truncate text-gray-400 cursor-help">
                        {shortAddress(token)}
                      </div>
                    </TooltipTrigger>
                    <TooltipContent className="text-xs">{token}</TooltipContent>
                  </Tooltip>
                </TooltipProvider>
              ) : account ? (
                <div className="text-xs text-gray-400 truncate">
                  {shortAddress(account)}
                </div>
              ) : null}
            </div>
          </div>
        );
      })}
    </div>
  );
};
